module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body user_wrp_res"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: (['createUser']),
      expression: "['createUser']",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserCreate',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('button', {
    staticClass: " btn gradientbt"
  }, [_vm._v("Add User")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "userTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.action(props.row)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "py-2 text-center row"
        }, [_c('label', {
          staticClass: "toggle"
        }, [_c('input', {
          staticClass: "toggle-checkbox",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.isActive
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.activateUserModal(props.row); })($event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "slider"
        })])])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0131c912", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0131c912"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/users/Users.vue
// module id = 2243
// module chunks = 0